<template>
  <section id="test-vocacional">
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-10 mx-auto d-flex justify-content-center align-items-center">
          <div class="content-wrapper my-5 bg-white rounded p-4 pb-5 w-100 position-relative">
            <!-- body -->
            <div class="row">
              <div class="col-12 col-md-8 mx-auto">
                <form @submit.prevent="onSubmit" autocomplete="off">
                  <div v-if="!questionStore.knowStudy" class="text-center">
                    <h3 class="form-question mb-1">¡Enhorabuena!</h3>
                    <h4 class="text-color-primary mt-1 font-weight-bold">Ya tenemos los resultados para tu test</h4>
                    <p class="font-weight-bold">Rellena este formulario para poder acceder a ellos</p>
                  </div>
                  <div v-else class="text-center">
                    <h3 class="form-question mb-1">¡Enhorabuena!</h3>
                    <p class="font-weight-bold">Rellena este formulario y conoce tu futura titulación universitaria</p>
                  </div>
                  <input class="form-control mb-3" v-model="form.name" :class="{ 'error': v$.name.$error }" type="text" name="name" placeholder="Nombre *" autocomplete="given-name">

                  <div class="row">
                    <div class="col-12 col-md-6">
                      <input class="form-control mb-3" v-model="form.lastname" :class="{ 'error': v$.lastname.$error }" type="text" name="lastname" :placeholder="$t('apellido1') + ' *'"  autocomplete="family-name">
                    </div>
                    <div class="col-12 col-md-6">
                      <input class="form-control mb-3" v-model="form.lastname2" :class="{ 'error': v$.lastname2.$error }" type="text" name="lastname2" :placeholder="$t('apellido2')"  autocomplete="additional-name">
                    </div>
                  </div>
                  <input class="form-control mb-3" v-model="form.email" :class="{ 'error': v$.email.$error }" type="text" name="email" placeholder="Email *"  autocomplete="email">
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text">+34</span>
                    </div>
                    <input class="form-control" v-model="form.tlf" :class="{ 'error': v$.tlf.$error }" type="text" name="tlf" placeholder="Teléfono *">
                  </div>
                  <div class="selectVueContainer">
                    <v-select class="form-control mb-3 px-0" :placeholder="$t('provincia') + ' *'" v-model="form.province" :class="{ 'error': v$.province.$error }" :reduce="provincia => provincia.idSigmaExt" :options="provincias" label="nombre" />
                  </div>
                  <div class="selectVueContainer" v-if="form.province">
                    <v-select class="form-control mb-3 px-0 h-auto" placeholder="Centro de estudios *" v-model="form.center" :class="{ 'error': v$.center.$error }"  :reduce="centro => centro.idSigmaExt" :options="questionStore.centers" :filter="customFilter" label="nombre"/>
                  </div>
                  <div v-if="questionStore.knowStudy" class="selectVueContainer">
                    <v-select class="form-control mb-3 px-0 h-auto" placeholder="Curso académico *" v-model="form.academicYear" :class="{ 'error': v$.academicYear.$error }" :reduce="academicYear => academicYear" :options="studyStore.academicYears" />
                  </div>
                  <div v-if="questionStore.knowStudy && form.academicYear" class="selectVueContainer">
                    <v-select class="form-control mb-3 px-0 h-auto" placeholder="Titulación *" v-model="form.study" :class="{ 'error': v$.study.$error }" :reduce="study => study.idCl" :options="studiesFilters" label="nombre"  />
                  </div>
                  <div class="selectVueContainer">
                    <v-select class="form-control mb-3 px-0 h-auto" placeholder="Estudios Cursados *" v-model="form.estudioCursado" :class="{ 'error': v$.estudioCursado.$error }" :reduce="estudioCursado => estudioCursado.value" :options="estudiosCursados" label="text" />
                  </div>
                  <div class="selectVueContainer">
                    <v-select class="form-control mb-3 px-0" :placeholder="$t('canalContacto') + ' *'" v-model="form.contactCanal" :class="{ 'error': v$.contactCanal.$error }" :reduce="canalContacto => canalContacto.value" :options="canalesContacto" label="text" />
                  </div>
                  <div class="row">
                    <div class="col-12 col-md-10 mt-3 mx-auto text-left">
                      <div class="form-group">
                        <div class="form-check">
                          <label><input v-model="form.inputterm" :class="{ 'error': v$.inputterm.$error }" class="form-check-input" type="checkbox" name="inputTerms"> Acepto los términos y condiciones</label> <a href="#" data-toggle="collapse" data-target="#terminos-condiciones-test"><i class="icon icon-artboard-1-copy-10-copia"></i></a> <br>
                          <p id="terminos-condiciones-test" class="collapse"><small>El responsable de tratamiento de los datos personales es la FUNDACION UNIVERSITARIA SAN ANTONIO. Sus datos personales serán tratados para la gestión de las actividades de información y asesoramiento, atención de su consulta y el envío de comunicaciones promocionales y de servicios vinculados a la Institución. La base legal del tratamiento es su consentimiento. Sus datos serán conservados de forma indefinida hasta que no solicite su cancelación. Puede ampliar la información sobre la Política de Privacidad en www.ucam.edu. Puede contactar con el Delegado de Protección de datos en dpd@ucam.edu. Tiene derecho a acceder a esta información, rectificarla, cancelarla, y demás derechos recogidos en la LOPD y reglamento UE 2016/679 dirigiéndose a la Secretaría de la Universidad de forma presencial o por escrito acreditando su identificación en secretaria@ucam.edu.</small></p>
                        </div>
                        <div class="form-check">
                          <label><input v-model="form.comercial" :class="{ 'error': v$.comercial.$error }" class="form-check-input" type="checkbox" name="e_comercial" value="S"> Deseo recibir comunicaciones comerciales</label>
                        </div>
                      </div>
                      <div class="mt-3">
                        <button type="submit" class="btn btn-primary btn-block" :disabled="isSubmitting">
                          Enviar
                        </button>
                        <a v-if="questionStore.knowStudy" @click="questionStore.changeStepWithReset('start')" class="btn btn-ucam-gray-lighter btn-block"> Volver </a>
                      </div>
                    </div>
                  </div>

                </form>
                <div class="row mt-3">
                  <div class="col-12">
                    <p v-if="!questionStore.knowStudy" class="font-weight-bold">Te enviaremos el resultado al email que nos has facilitado para que lo tengas siempre a mano.</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- ./end body -->
          </div>

        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import {useQuestionStore} from "@/stores/question.js";
import {useVuelidate} from "@vuelidate/core";
import {required, email, minLength, requiredIf, maxLength, sameAs, numeric} from '@vuelidate/validators';
import {computed, onBeforeMount, reactive, ref, watch} from "vue";
import {useStudyStore} from "@/stores/studies.js";

const questionStore = useQuestionStore()
const studyStore = useStudyStore()

const studiesFilters = computed(()=>{
  return studyStore.studies.filter(estudio => {
    return estudio.anioAcademico === form.academicYear
  })
})

const customFilter = (options, search) => {
  if (!search) {
    return options
  }

  const searchNormalized = search.normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()

  return options.filter(option => {
    // Si las opciones son objetos
    const label = option.nombre.normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim()
    return label.includes(searchNormalized)
  })
}

const form = reactive({
  email:'',
  name:'',
  lastname:'',
  lastname2:'',
  tlf: '',
  inputterm: '',
  contactCanal: '',
  comercial: '',
  province:  '',
  study: '',
  center: '',
  estudioCursado: '',
  academicYear: ''
})

const rules = {
  name: { required, min: minLength(2), max: maxLength(150) },
  lastname: { required, min: minLength(2), max: maxLength(150) },
  lastname2: { max: maxLength(150) },
  email: { required, email },
  tlf:  { required, numeric, min: minLength(6) },
  province: { required },
  inputterm:  { sameAsTrue: sameAs(true) },
  contactCanal:  { required },
  study: {
    required : requiredIf(function() {
      return questionStore.knowStudy;
    })
  },
  center: { required },
  estudioCursado: { required },
  academicYear: {
    required : requiredIf(function() {
      return questionStore.knowStudy;
    })
  },
  comercial: {
    sameAsTrue: (value) => questionStore.knowStudy || value === true
  }
}

const v$ = useVuelidate(rules, form);

const isSubmitting = ref(false)

const onSubmit = () => {
  v$.value.$touch();
  if(v$.value.$error) return
  if (isSubmitting.value) return;

  isSubmitting.value = true;
  form.bestResult = questionStore.bestResult
  questionStore.sendForm(form)
}

let provincias = ref([])
const canalesContacto = [
  { value: 'Call', text: 'Llamada' },
  { value: 'E-Mail', text: 'Email' },
  { value: 'WhatsApp', text: 'WhatsApp' }
]
const estudiosCursados = [
  { value: '4 ESO', text: '4º ESO' },
  { value: 'Baccalaureate 1', text: 'Primero de bachiller' },
  { value: 'Baccalaureate 2', text: 'Segundo de bachiller' },
  { value: 'Technical/Vocational', text: 'FP Grado Superior' },
  { value: 'Over 25', text: 'Mayores 25' },
  { value: 'Over 45', text: 'Mayores 45' },
  { value: 'Bachelor\'s Degree', text: 'Grado universitario' }
]

onBeforeMount(async () => {
  await studyStore.fetchStudies()
  provincias.value = await questionStore.loadProvincies()
})

watch(() => form.province, (newValue) => {
  form.center = "";
  questionStore.getCentersByProvince(newValue);
}, {deep: true, immediate: false})

</script>

<style scoped>
  .selectVueContainer{
    position: relative;
  }
  .form-control.error {
    border-bottom-color: red;
  }
  label:has(.form-check-input.error){
    color: red;
  }
</style>

<style>
  .selectVueContainer .v-select .vs__dropdown-toggle{
    border: none;
  }
  .vs__selected{
    color: #666!important;
  }
</style>
